<template>
  <div :class="[modal === true ? 'modal-overlay' : '']">
    <div
      ref="kt_modal_emitente_pacote"
      data-bs-backdrop="static"
      data-bs-focus="false"
      :class="[modal === true ? 'modal fade' : '']"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
      id="kt_modal_emitente_pacote"
    >
      <div
        class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div v-if="modal === true" class="modal-header">
            <h3 class="modal-title">
              <img
                src="media/icons/duotune/general/gen002.svg"
                class="me-2"
              />Atualizar de Plano
            </h3>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="this.$emit('exibirModalEmitentePacote', false)"
            >
              <span class="svg-icon svg-icon-2x">
                <img src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4"
            >
              <div class="card card-bordered">
                <div class="card-header bg-light min-h-50px">
                  <div class="card-title">
                    <h3>Pacote</h3>
                  </div>
                </div>
                <div class="card-body pt-4 pb-0">
                  <div class="row">
                    <div
                      class="col-sm-12 col-md-12 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                    >
                      <label for="txtTipoPacote" class="required form-label"
                        >Tipo Pacote</label
                      >
                      <select
                        class="form-select"
                        aria-label="tipo_pacote"
                        v-model="this.emitente.tipo_pacote"
                        @change="this.calcularValorPacote()"
                        :readonly="
                          this.exibirTelaResumida === true ? true : false
                        "
                        :disabled="
                          this.exibirTelaResumida === true ? true : false
                        "
                      >
                        <option value="0">Emissor Gratuíto</option>
                        <option value="1">Emissor</option>
                        <option value="2">Gestor</option>
                        <option value="3">Indústria</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["tipo_pacote"] }}
                      </div>
                    </div>
                    <div class="col-auto fv-row mb-4">
                      <label class="form-label">Qtd Terminais</label>
                      <div class="col">
                        <el-input-number
                          id="txtQtdTerminais"
                          :disabled="
                            this.emitente.tipo_pacote === '0' ? true : false
                          "
                          v-model="this.emitente.qtd_terminais"
                          class="w-150px"
                          :min="1"
                          :max="500"
                          size="large"
                          controls-position="right"
                          @change="this.calcularValorPacote()"
                        />
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["qtd_terminais"] }}
                      </div>
                    </div>
                    <div class="col-auto fv-row mb-4">
                      <label class="form-label">Qtd PDV</label>
                      <div class="col">
                        <el-input-number
                          id="txtQtdPDV"
                          :disabled="
                            this.emitente.tipo_pacote === '0' ? true : false
                          "
                          v-model="this.emitente.qtd_pdv"
                          class="w-150px"
                          :min="0"
                          :max="500"
                          size="large"
                          controls-position="right"
                          @change="this.calcularValorPacote()"
                        />
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["qtd_pdv"] }}
                      </div>
                    </div>
                    <div
                      v-if="
                        this.exibirTelaResumida === false ||
                        (this.exibirTelaResumida === true &&
                          this.isRevenda === false)
                      "
                      class="col-auto fv-row mb-4"
                    >
                      <label class="required form-label">Valor Contrato</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        style="text-align: right"
                        v-model="this.emitente.valor_contrato"
                        :options="options"
                        :readonly="
                          this.emitente.tipo_pacote === '0' ||
                          this.user.User.TipoUsuario.tipo != 'Administrador'
                            ? true
                            : false
                        "
                        :disabled="
                          this.emitente.tipo_pacote === '0' ||
                          this.user.User.TipoUsuario.tipo != 'Administrador'
                            ? true
                            : false
                        "
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["valor_contrato"] }}
                      </div>
                    </div>
                    <div
                      v-if="
                        this.exibirTelaResumida === false ||
                        (this.exibirTelaResumida === true &&
                          this.isRevenda === false)
                      "
                      class="col-auto fv-row d-flex align-items-center mb-4"
                    >
                      <button
                        @click="detalhesPacote()"
                        type="button"
                        class="btn btn-sm btn-light-primary btn-active-primary"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/general/gen025.svg" /></span
                        >Detalhes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="modal === true"
            class="modal-footer d-flex justify-content-end"
          >
            <button
              class="btn btn-danger svg-icon-white me-2 mb-2"
              data-bs-dismiss="modal"
              @click="this.$emit('exibirModalEmitentePacote', false)"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr015.svg"
                  class="me-2"
                />Cancelar
              </span>
            </button>
            <button
              class="btn btn-success svg-icon-white mb-2"
              @click="this.confirmar()"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg
                  src="media/icons/duotune/arrows/arr016.svg"
                  class="me-2"
                />Confirmar
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { mapState } from "vuex";
import CurrencyInput from "@/components/text/CurrencyInput";

export default {
  emits: [
    "exibirModalEmitentePacote",
    "confirmarEmitentePacote",
    "update:errosValidacao",
  ],
  props: {
    emitentePacote: { type: Object, required: true },
    modal: { type: Boolean, required: true },
    errosValidacao: { type: Object, required: false },
    exibirTelaResumida: { type: Boolean, required: false, default: false },
    isRevenda: { type: Boolean, required: true },
  },
  components: {
    CurrencyInput,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async confirmar() {
      this.$emit("confirmarEmitentePacote", this.emitente);
    },
    calcularValorPacote() {
      if (this.emitente.tipo_pacote) {
        let valorPacote = 0;
        const tipoPacote = parseInt(this.emitente.tipo_pacote, 10);

        switch (tipoPacote) {
          case 0:
            valorPacote = 0;
            this.emitente.qtd_terminais = 1;
            this.emitente.qtd_pdv = 0;
            break;
          case 1:
            valorPacote = this.isRevenda ? 25 : 100;
            break;
          case 2:
            valorPacote = this.isRevenda ? 60 : 150;
            break;
          case 3:
            valorPacote = this.isRevenda ? 100 : 200;
            break;
          default: // Defina um valor padrão como string se necessário
            this.emitente.tipo_pacote = "1";
            valorPacote = this.isRevenda ? 25 : 100;
            break;
        }

        //Calcular valor dos terminais adicionais
        if (this.emitente.qtd_terminais > 1) {
          let qtdTerminais = this.emitente.qtd_terminais - 1;
          valorPacote += qtdTerminais * (this.isRevenda ? 10 : 20);
        }

        //Calcular valor dos pdv's
        if (this.emitente.qtd_pdv > 0) {
          let qtdPDV = this.emitente.qtd_pdv;
          valorPacote += qtdPDV * (this.isRevenda ? 25 : 50);
        }

        this.emitente.valor_contrato = valorPacote;
      }
    },
    async detalhesPacote() {
      await this.$swal.showInfoAlert(
        "<h3>Valor dos Pacotes</h3><p><strong>Emissor</strong> : R$ 30,00</p><p><strong>Gestor</strong> : R$ 60,00</p><p><strong>Indústria</strong> : R$ 100,00</p><p class='mt-8'><strong>Terminal adicional</strong> : R$ 10,00</p><p><strong>PDV adicional</strong> : R$ 30,00</p>"
      );
    },
  },
  async mounted() {
    this.emitente = this.emitentePacote;
  },
  data() {
    return {
      emitente: this.emitentePacote,
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: {
          min: 2,
        },
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: true,
      },
    };
  },
};
</script>

<style></style>
